import axios, { Axios } from 'axios';
import Config from '../config';
import { AxiosInstance } from '../helpers/AxiosInstance';
import { getClientIp } from '../helpers/ip-address.helper';

const getHeaders = async (extraHeaders = {}) => {
    const ip = await getClientIp();
    return {
        'X-Client-IP': ip,
        ...extraHeaders
    };
};

const getSecureDocs = async (id: any) => {
    const headers = await getHeaders();
    return AxiosInstance.get(`${Config.API_SECOND_URL}/falkondocs/api/v1/user/files/${id}`, { headers });
};

const saveSecureDocs = async (data: any) => {
    const headers = await getHeaders();
    return AxiosInstance.post(`${Config.API_SECOND_URL}/falkondocs/api/v1/save-doc`, data, { headers });
};

const updateSecureDocs = async (id: any, data: any) => {
    const headers = await getHeaders();
    return AxiosInstance.put(`${Config.API_SECOND_URL}/falkondocs/api/v1/update-doc/${id}`, data, { headers });
};

const deleteSignedSecureDoc = async (id: any) => {
    const headers = await getHeaders();
    return AxiosInstance.delete(`${Config.API_SECOND_URL}/falkondocs/api/v1/delete-doc/${id}`, { headers });
};

const getSignedSecureDocUpdateInfo = async (id: any) => {
    const headers = await getHeaders();
    return AxiosInstance.get(`${Config.API_SECOND_URL}/falkondocs/api/v1/doc/${id}`, { headers });
};

const getFileConfigurations = async (id: any) => {
    const headers = await getHeaders();
    return AxiosInstance.get(`${Config.API_SECOND_URL}/falkondocs/api/v1/file/${id}`, { headers });
};

const setFileConfigurations = async (id: any, data: any) => {
    const headers = await getHeaders();
    return AxiosInstance.post(`${Config.API_SECOND_URL}/falkondocs/api/v1/add-config/${id}`, data, { headers });
};

const modifyFileConfigurations = async (id: any, data: any) => {
    const headers = await getHeaders();
    return AxiosInstance.put(`${Config.API_SECOND_URL}/falkondocs/api/v1/modify-config/${id}`, data, { headers });
};

const sendSecureDocOtp = async (id: any) => {
    const headers = await getHeaders();
    return axios.post(`${Config.API_SECOND_URL}/falkondocs/api/v1/signer/sendotp/${id}`, {}, { headers });
};

const sendCompletedSecureDocOtp = async (id: any) => {
    const headers = await getHeaders();
    return axios.post(`${Config.API_SECOND_URL}/falkondocs/api/v1/completed/sendotp/${id}`, {}, { headers });
};

const openSecureDocWithOtp = async (id: any, data: any) => {
    const headers = await getHeaders();
    return axios.post(`${Config.API_SECOND_URL}/falkondocs/api/v1/signer/open/${id}`, data, { headers });
};

const markAsCompleted = async (id: any, data: any, token: string) => {
    const headers = await getHeaders({
        Authorization: `Bearer ${token}`,
    });
    return axios.post(`${Config.API_SECOND_URL}/falkondocs/api/v1/mark/element/${id}`, data, { headers });
};

const openCompletedSecureDocWithOtp = async (id: any, data: any) => {
    const headers = await getHeaders();
    return axios.post(`${Config.API_SECOND_URL}/falkondocs/api/v1/completed/open/${id}`, data, { headers });
};

const downloadCompletedSecureDocWithoutOtp = async (id: any) => {
    const headers = await getHeaders();
    return AxiosInstance.post(`${Config.API_SECOND_URL}/falkondocs/api/v1/download/owner/${id}`, {}, { headers });
};

export const SecureDocsService = {
    getSecureDocs,
    saveSecureDocs,
    updateSecureDocs,
    deleteSignedSecureDoc,
    getSignedSecureDocUpdateInfo,
    getFileConfigurations,
    setFileConfigurations,
    modifyFileConfigurations,
    sendSecureDocOtp,
    sendCompletedSecureDocOtp,
    openSecureDocWithOtp,
    markAsCompleted,
    openCompletedSecureDocWithOtp,
    downloadCompletedSecureDocWithoutOtp

}